"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _mobxReact = require("mobx-react");

var _mobxStateTree = require("mobx-state-tree");

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));

var _Minimize = _interopRequireDefault(require("@material-ui/icons/Minimize"));

var _MoreVert = _interopRequireDefault(require("@material-ui/icons/MoreVert"));

var _Drawer = _interopRequireDefault(require("./Drawer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// icons
// locals
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    drawerActions: {
      float: 'right',
      '&:hover': {
        backgroundColor: (0, _core.alpha)(theme.palette.secondary.contrastText, theme.palette.action.hoverOpacity),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },
    drawerToolbar: {
      paddingLeft: theme.spacing(2)
    },
    spacer: {
      flexGrow: 1
    },
    drawerSelect: {
      color: theme.palette.secondary.contrastText
    },
    drawerLoading: {
      margin: theme.spacing(2)
    },
    dropDownIcon: {
      color: theme.palette.secondary.contrastText
    },
    header: {
      background: theme.palette.secondary.main
    }
  };
});
var DrawerHeader = (0, _mobxReact.observer)(function (_ref) {
  var session = _ref.session,
      setToolbarHeight = _ref.setToolbarHeight;

  var _getEnv = (0, _mobxStateTree.getEnv)(session),
      pluginManager = _getEnv.pluginManager;

  var visibleWidget = session.visibleWidget,
      activeWidgets = session.activeWidgets,
      drawerPosition = session.drawerPosition;
  var classes = useStyles();

  var _React$useState = _react.default.useState(null),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  return /*#__PURE__*/_react.default.createElement(_core.AppBar, {
    position: "sticky",
    className: classes.header,
    ref: function ref(_ref2) {
      return setToolbarHeight((_ref2 === null || _ref2 === void 0 ? void 0 : _ref2.getBoundingClientRect().height) || 0);
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Toolbar, {
    disableGutters: true,
    className: classes.drawerToolbar
  }, /*#__PURE__*/_react.default.createElement(_core.Select, {
    value: visibleWidget === null || visibleWidget === void 0 ? void 0 : visibleWidget.id,
    "data-testid": "widget-drawer-selects",
    className: classes.drawerSelect,
    classes: {
      icon: classes.dropDownIcon
    },
    renderValue: function renderValue(widgetId) {
      var widget = session.activeWidgets.get(widgetId);

      if (!widget) {
        return /*#__PURE__*/_react.default.createElement(_core.Typography, {
          variant: "h6",
          color: "inherit"
        }, "Unknown widget");
      }

      var widgetType = pluginManager.getWidgetType(widget.type);
      var HeadingComponent = widgetType.HeadingComponent,
          heading = widgetType.heading;
      return HeadingComponent ? /*#__PURE__*/_react.default.createElement(HeadingComponent, {
        model: widget
      }) : /*#__PURE__*/_react.default.createElement(_core.Typography, {
        variant: "h6",
        color: "inherit"
      }, heading);
    },
    onChange: function onChange(e) {
      var w = session.activeWidgets.get(e.target.value);

      if (!w) {
        session.notify('Widget not found ' + e.target.value, 'warning');
      }

      session.showWidget(w);
    }
  }, Array.from(activeWidgets.values()).map(function (widget) {
    var widgetType = pluginManager.getWidgetType(widget.type);
    var HeadingComponent = widgetType.HeadingComponent,
        heading = widgetType.heading;
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      "data-testid": "widget-drawer-selects-item-".concat(widget.type),
      key: widget.id,
      value: widget.id
    }, HeadingComponent ? /*#__PURE__*/_react.default.createElement(HeadingComponent, {
      model: widget
    }) : /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6",
      color: "inherit"
    }, heading), /*#__PURE__*/_react.default.createElement(_core.ListItemSecondaryAction, null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      "data-testid": "".concat(widget.type, "-drawer-delete"),
      color: "inherit",
      "aria-label": "Delete",
      onClick: function onClick() {
        session.hideWidget(widget);
      }
    }, /*#__PURE__*/_react.default.createElement(_Delete.default, null))));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.spacer
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "data-testid": "drawer-close",
    color: "inherit",
    onClick: function onClick(event) {
      return setAnchorEl(event.currentTarget);
    }
  }, /*#__PURE__*/_react.default.createElement(_MoreVert.default, null)), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Minimize drawer"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "data-testid": "drawer-minimize",
    color: "inherit",
    onClick: function onClick() {
      session.minimizeWidgetDrawer();
    }
  }, /*#__PURE__*/_react.default.createElement(_Minimize.default, null))), /*#__PURE__*/_react.default.createElement(_core.Tooltip, {
    title: "Close drawer"
  }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
    "data-testid": "drawer-close",
    color: "inherit",
    onClick: function onClick() {
      session.hideWidget(visibleWidget);
    }
  }, /*#__PURE__*/_react.default.createElement(_Close.default, null))))), /*#__PURE__*/_react.default.createElement(_core.Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onClose: function onClose() {
      return setAnchorEl(null);
    }
  }, ['left', 'right'].map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_core.MenuItem, {
      key: option,
      selected: drawerPosition === 'option',
      onClick: function onClick() {
        session.setDrawerPosition(option);
        setAnchorEl(null);
      }
    }, option);
  })));
});
var DrawerWidget = (0, _mobxReact.observer)(function (_ref3) {
  var session = _ref3.session;
  var visibleWidget = session.visibleWidget;

  var _getEnv2 = (0, _mobxStateTree.getEnv)(session),
      pluginManager = _getEnv2.pluginManager;

  var DrawerComponent = visibleWidget ? pluginManager.getWidgetType(visibleWidget.type).ReactComponent : null; // we track the toolbar height because components that use virtualized
  // height want to be able to fill the contained, minus the toolbar height
  // (the position static/sticky is included in AutoSizer estimates)

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      toolbarHeight = _useState2[0],
      setToolbarHeight = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(_Drawer.default, {
    session: session
  }, /*#__PURE__*/_react.default.createElement(DrawerHeader, {
    session: session,
    setToolbarHeight: setToolbarHeight
  }), /*#__PURE__*/_react.default.createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react.default.createElement("div", null, "Loading...")
  }, /*#__PURE__*/_react.default.createElement(DrawerComponent, {
    model: visibleWidget,
    session: session,
    toolbarHeight: toolbarHeight
  })));
});
var _default = DrawerWidget;
exports.default = _default;